import {createRouter, createWebHistory} from 'vue-router';
import {useSessionStore} from '@/stores/session';
import Main from "@/views/Main.vue";
import Profile from "@/views/Profile.vue";
import {isShopQR} from "@/common/utils";

const router = createRouter({
  history: createWebHistory(),
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/',
    component: Main,
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/Home.vue'),
    }, {
      path: 'control-board',
      name: 'controlBoard',
      component: () => import('@/views/ControlBoard.vue'),
    }, {
      path: 'shop',
      name: 'shops',
      component: () => import('@/views/Shops.vue'),
    }, {
      path: 'device',
      name: 'devices',
      component: () => import('@/views/Devices.vue'),
    }, {
      path: 'schedule',
      name: 'schedules',
      component: () => import('@/views/Schedules.vue'),
    }, {
      path: 'log',
      name: 'logs',
      component: () => import('@/views/Logs.vue'),
    }, {
      path: 'partner',
      name: 'partners',
      component: () => import('@/views/Partners.vue'),
    }, {
      path: 'remocon',
      name: 'remocons',
      component: () => import('@/views/Remocons.vue'),
    }, {
      path: 'program',
      name: 'programs',
      component: () => import('@/views/Programs.vue'),
    }, {
      path: 'post',
      name: 'posts',
      component: () => import('@/views/Posts.vue'),
    }, {
      path: 'faq',
      name: 'faq-list',
      component: () => import('@/views/FaqBoard.vue'),
    }, {
      path: 'faq/write',
      name: 'faq-write',
      component: () => import('@/views/FaqEditor.vue'),
    }, {
      path: 'faq/:id',
      name: 'faq-detail',
      component: () => import('@/views/FaqDetail.vue'),
      props: true,
    }, {
      path: 'faq/:id/edit',
      name: 'faq-edit',
      component: () => import('@/views/FaqEditor.vue'),
      props: true,
    }, {
      path: 'setting',
      name: 'settings',
      component: () => import('@/views/Settings.vue'),
    }, {
      path: 'profile', name: 'profile', component: Profile
    }]
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  }, {
    path: '/login/qr',
    name: 'qrLogin',
    component: () => import('@/views/QRLogin.vue'),
  }, {
    path: '/login/password',
    name: 'passwordLogin',
    component: () => import('@/views/PasswordLogin.vue'),
  }, {
    path: '/:pathMatch(.*)*',
    redirect: '/',
    // component: () => import('@/views/NotFound.vue'),
  }]
});

// http://localhost:5173/login/qr?t=s242_q00008.LxZur3RCiemoA5Vy
router.beforeEach(async (to, from) => {
  const sessionStore = useSessionStore();
  const loginNames = ['login', 'qrLogin', 'passwordLogin'];

  const account = sessionStore.profile && sessionStore.profile.account;

  // 인증되지 않은 사용자의 로그인외 페이지 요청시 로그인으로 이동
  if (!sessionStore.authorized && !loginNames.includes(to.name))
    return {name: 'login'};

  // 로그인한 qr 사용자의 qr 로그인으로 이동
  else if (to.name !== 'qrLogin' && sessionStore.authorized && isShopQR(sessionStore.profile?.account))
    return {name: 'qrLogin'};

  // qr 사용자 외 인증된 사용자가 로그인 페이지 요청시 / 이동
  else if (account && !isShopQR(account) && sessionStore.authorized && loginNames.includes(to.name))
    return {path: '/'};

  return true;
});

export default router;
